<template>
  <BaseFormLayout
    :title="`${orderModule.order} Split ( ${orderDetails.reference_number} )`"
  >
    <template #actions>
      <SecondaryButton
        id="orderItemSplitReset"
        btnClass="mr-2 text-uppercase rounded-lg"
        name="Reset"
        @click="resetForm"
      >
      </SecondaryButton>
      <PrimaryButton
        id="orderItemSplitSubmit"
        name="Submit"
        btnClass="text-uppercase rounded-lg"
        @click="submitForm"
        :disabled="!checkIsItems || !isValid"
      >
      </PrimaryButton>
    </template>
    <template #content>
      <div
        class="app-layout"
        style="height: calc(100vh - 150px); width: calc(100vw - 80px)"
      >
        <div class="app-layout-grid">
          <div class="list">
            <v-card elevation="0" class="rounded-lg mb-3">
              <v-card-title>
                <v-row no-gutters>
                  <v-col cols="8">
                    <h5 class="text_color--text">
                      {{ orderModule.orderPlural }} Split ({{
                        originList.length
                      }})
                    </h5>
                  </v-col>
                  <v-col class="text-right"> </v-col>
                  <v-col class="text-right"> </v-col>
                </v-row>
              </v-card-title>
              <v-card-text class="d-flex pt-0 pb-5 app-custom-search-input">
                <InputField
                  id="search_order"
                  name="search_order"
                  class="mr-1"
                  :label="`search ${orderModule.order}`"
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  v-model="search"
                  background-color="background_color"
                  dense
                  hide-details="auto"
                  clearable
                  @keydown.enter="getOrderList(true)"
                >
                </InputField>
                <!-- <OrderFilters
              :filter="orderNewFilters"
              @apply="getOrderList(true)"
              @reset="resetFilters"
              :isChips="Object.keys(orderNewFilters).length > 0"
            /> -->
              </v-card-text>

              <v-row no-gutters class="pb-3 px-3">
                <v-col class="px-1 pb-1">
                  <v-card elevation="0" class="h-100 rounded-lg" outlined>
                    <v-card-text
                      class="px-4 py-2 h-100 d-flex flex-column justify-space-between"
                    >
                      <span
                        class="text-capitalize text-left text-caption font-weight-bold"
                      >
                        Total CBM
                      </span>

                      <div class="d-flex algin-center">
                        <v-icon small class="mr-2" color="error"
                          >mdi-package-variant-closed</v-icon
                        >

                        <span class="text-caption">
                          <h4 class="text-nowrap text-caption">
                            {{ oldOrderCBM }}
                          </h4>
                        </span>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col class="px-1 pb-1">
                  <v-card elevation="0" class="h-100 rounded-lg" outlined>
                    <v-card-text
                      class="px-4 py-2 h-100 d-flex flex-column justify-space-between"
                    >
                      <span
                        class="text-capitalize text-left text-caption font-weight-bold"
                      >
                        Total Weight
                      </span>

                      <div class="d-flex algin-center">
                        <v-icon small class="mr-2" color="success"
                          >mdi-weight</v-icon
                        >

                        <span class="text-caption">
                          <h4 class="text-nowrap text-caption">
                            {{ oldOrderWeight }}
                          </h4>
                        </span>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
            <v-card
              elevation="0"
              class="rounded-lg overflow-y-auto app-list w-100"
              style="overflow-y: auto; height: calc(100vh - 360px)"
              id="order-split-target"
            >
              <v-expansion-panels
                v-model="orderExpansion"
                flat
                multiple
                readonly
                class="background_color"
              >
                <v-expansion-panel
                  expand-icon=""
                  elevation="0"
                  v-for="(item, i) in originList"
                  :key="i"
                  class="pa-0 ma-0 background_color"
                >
                  <div
                    class="mb-2"
                    v-show="item && Object.keys(item).length > 0"
                    :draggable="!item.isDraggable"
                    @dragstart="itemDragStart(item.id)"
                  >
                    <OrderItemCard :itemDetails="item" />
                  </div>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </div>
          <div class="app-order-layout-grid-right pl-4 pb-2 d-flex flex-column">
            <v-card elevation="0" class="w-100 rounded-lg px-3 py-3 mb-4">
              <v-row>
                <v-col cols="12" class="text-right">
                  <PrimaryButton name="Create Empty Order" disabled />
                </v-col>
              </v-row>
            </v-card>
            <v-form v-model="isValid">
              <v-card
                elevation="0"
                class="w-100 rounded-lg pa-4 overflow-y-auto"
                style="height: calc(100vh - 240px)"
              >
                <v-expansion-panels
                  v-for="(order, orderIndex) in splittedOrderList"
                  :key="orderIndex"
                  flat
                  class="mb-3"
                  v-model="expansionList"
                >
                  <v-expansion-panel outlined>
                    <v-expansion-panel-header
                      class="primary pa-3"
                      expand-icon="mdi-menu-down"
                      style="min-height: 20px !important"
                    >
                      <v-row no-gutters class="pl-1">
                        <v-col cols="2" class="d-flex align-center">
                          <h4 class="white--text font-weight-bold">
                            Split order {{ orderIndex + 1 }}
                          </h4>
                        </v-col>
                        <v-col cols="2"></v-col>
                        <v-col cols="3" class="px-3">
                          <v-chip
                            color="white"
                            class="w-100"
                            label
                            v-show="newOrderCBM(orderIndex) != 0"
                          >
                            Total
                            <span class="ml-2 font-weight-bold"
                              >{{ newOrderCBM(orderIndex) }} CBM</span
                            >
                          </v-chip>
                        </v-col>
                        <v-col cols="3" class="px-3">
                          <v-chip
                            color="white"
                            class="w-100"
                            label
                            v-show="newOrderWeight(orderIndex) != 0"
                          >
                            Total
                            <span class="ml-2 font-weight-bold"
                              >{{ newOrderWeight(orderIndex) }} Kg</span
                            >
                          </v-chip>
                        </v-col>

                        <v-col cols="2"></v-col>
                      </v-row>
                      <template v-slot:actions>
                        <v-icon> mdi-chevron-down </v-icon>
                      </template>
                    </v-expansion-panel-header>
                    <v-card outlined>
                      <v-expansion-panel-content
                        style="
                          min-height: 140px !important;
                          max-height: 450px !important;
                        "
                        class="rounded-lg pa-4 overflow-y-auto"
                      >
                        <div
                          @dragenter.stop.prevent
                          @dragover.stop.prevent
                          @drop.stop.prevent="dropOrder(orderIndex)"
                          style="
                            min-height: 140px !important;
                            max-height: 450px !important;
                          "
                        >
                          <v-row no-gutters class="py-2">
                            <v-col cols="2">
                              <h5>Item No</h5>
                            </v-col>
                            <v-col cols="2" class="text-center">
                              <h5>Storage Type</h5>
                            </v-col>
                            <v-col cols="2">
                              <h5>Volume (CBM)</h5>
                            </v-col>
                            <v-col cols="2">
                              <h5>Weight (KG)</h5>
                            </v-col>

                            <v-col cols="2" class="text-center">
                              <h5>Quantity</h5>
                            </v-col>
                            <v-col cols="2">
                              <h5 class="text-center">Action</h5>
                            </v-col>
                          </v-row>
                          <div>
                            <v-row
                              no-gutters
                              v-for="(item, itemIndex) in order.orderItem"
                              :key="itemIndex"
                              class="py-2"
                            >
                              <v-col cols="2">
                                <h5 class="text-caption">{{ item.item_no }}</h5>
                              </v-col>
                              <v-col cols="2" class="text-center">
                                <ItemType :type="item.storage_type"></ItemType>
                              </v-col>
                              <v-col cols="2">
                                <h5 class="text-caption">
                                  {{
                                    newItemVolume(
                                      item.item_original_volume,
                                      item.sales_quantity
                                    )
                                  }}
                                  CBM
                                </h5>
                              </v-col>
                              <v-col cols="2">
                                <h5 class="text-caption">
                                  {{
                                    newItemWeight(
                                      item.item_original_weight,
                                      item.sales_quantity
                                    )
                                  }}
                                  Kg
                                </h5>
                              </v-col>

                              <v-col cols="2">
                                <InputField
                                  id="split-item-Quantity"
                                  v-model="item.sales_quantity"
                                  label="Quantity"
                                  name="sales_quantity"
                                  required
                                  :rules="[
                                    (v) => !!v || 'sales quantity is required',
                                    (v) =>
                                      (!!v && 0 < parseInt(v) && v != 0) ||
                                      'sales quantity is greater than 0',
                                    (v) =>
                                      (!!v &&
                                        v <=
                                          parseFloat(item.original_quantity)) ||
                                      'sales quantity is less than original quantity is required',
                                  ]"
                                  @input="
                                    onChangeQuantity(item.oldIndex, item),
                                      errorBinding(
                                        orderIndex,
                                        itemIndex,
                                        'sales_quantity',
                                        true
                                      )
                                  "
                                  :error-messages="
                                    errorBinding(
                                      orderIndex,
                                      itemIndex,
                                      'sales_quantity',
                                      false
                                    )
                                  "
                                />
                              </v-col>
                              <v-col cols="2" class="text-center">
                                <v-icon
                                  color="error"
                                  @click="
                                    removeOrderFromSplit(orderIndex, itemIndex)
                                  "
                                  small
                                  >mdi-delete</v-icon
                                >
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                      </v-expansion-panel-content>
                    </v-card>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </v-form>
          </div>
        </div>
        <div></div>
      </div>
    </template>
  </BaseFormLayout>
</template>

<script>
import { bus } from "@/main";
import { orderModule } from "@/utils/moduleMapping";
import BaseFormLayout from "@/components/LayoutComponents/BaseFormLayout.vue";
import OrderItemCard from "@/components/ModuleBasedComponents/Order/OrderItemCard.vue";
import InputField from "@/components/ComponentLibrary/FormInput/InputField.vue";
import ItemType from "@/components/AgIcon/ItemType.vue";

export default {
  components: { BaseFormLayout, OrderItemCard, InputField, ItemType },
  data() {
    return {
      orderModule,
      isValid: false,
      search: null,
      totalCount: 0,
      itemList: [],
      dbItemList: [],
      splittedOrderList: [
        {
          orderItem: [],
        },
      ],
      singleOrderId: null,
      orderDetails: {},
      formErrors: null,
      expansionList: 0,
    };
  },
  computed: {
    checkIsItems() {
      return (
        this.splittedOrderList &&
        this.splittedOrderList.length > 0 &&
        this.splittedOrderList[0].orderItem.length > 0
      );
    },
    originList() {
      if (this.search) {
        return this.itemList.filter((v) => v.item_no.indexOf(this.search) > -1);
      } else {
        return this.itemList;
      }
    },
    oldOrderWeight() {
      return this.itemList
        .map((v) => v.item_original_weight * v.sales_quantity)
        .filter((v) => v != null)
        .reduce((p, c) => parseFloat(p) + parseFloat(c), 0)
        .toFixed(2);
    },
    oldOrderCBM() {
      return this.itemList
        .map((v) => v.item_original_volume * v.sales_quantity)
        .filter((v) => v != null)
        .reduce((p, c) => parseFloat(p) + parseFloat(c), 0)
        .toFixed(4);
    },
    orderExpansion: {
      get() {
        return this.itemList.map((item, index) => index);
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    selectedOrder() {
      return this.itemList.filter((item, index) => {
        if (item.isChecked) {
          item.oldIndex = index;
          item.isChecked = false;
          return true;
        }
      });
    },
    selectedOrderIds() {
      return this.selectedOrder.map((item) => item.id);
    },
  },
  methods: {
    errorBinding(orderIndex, itemIndex, key, isDeletable = false) {
      if (
        this.formErrors &&
        this.formErrors.order_item_id_list &&
        this.formErrors.order_item_id_list.length > 0
      ) {
        if (isDeletable) {
          delete this.formErrors.order_item_id_list[itemIndex][key];
        } else {
          return this.formErrors.order_item_id_list[itemIndex][key];
        }
      }
    },
    resetForm() {
      this.itemList = this.dbItemList;
      this.splittedOrderList = [
        {
          orderItem: [],
        },
      ];
    },
    newItemWeight(weight, quantity) {
      return (weight * quantity).toFixed(2);
    },
    newItemVolume(cbm, quantity) {
      return (cbm * quantity).toFixed(4);
    },
    newOrderCBM(orderIndex) {
      return this.splittedOrderList[orderIndex].orderItem
        .map((v) => v.item_original_volume * v.sales_quantity)
        .filter((v) => v != null)
        .reduce((p, c) => parseFloat(p) + parseFloat(c), 0)
        .toFixed(4);
    },
    newOrderWeight(orderIndex) {
      return this.splittedOrderList[orderIndex].orderItem
        .map((v) => v.item_original_weight * v.sales_quantity)
        .filter((v) => v != null)
        .reduce((p, c) => parseFloat(p) + parseFloat(c), 0)
        .toFixed(2);
    },
    onChangeQuantity(oldIndex, item) {
      this.itemList[oldIndex].sales_quantity =
        item.original_quantity - item.sales_quantity;
    },
    itemDragStart(id, tripIndex = null) {
      this.singleOrderId = id;
    },
    removeOrderFromSplit(orderIndex, itemIndex) {
      let removeItem = this.splittedOrderList[orderIndex].orderItem.splice(
        itemIndex,
        1
      )[0];

      if ((removeItem && removeItem.oldIndex) || removeItem.oldIndex == 0) {
        removeItem.sales_quantity = removeItem.original_quantity;
        this.itemList.splice(removeItem.oldIndex, 1, removeItem);
      } else {
        removeItem.sales_quantity = removeItem.original_quantity;
        this.itemList.push(removeItem);
      }
    },
    dropOrder(orderIndex) {
      if (this.selectedOrder.length > 0) {
        this.splittedOrderList[orderIndex].orderItem.push(
          ...this.selectedOrder
        );
        let newOrders = JSON.parse(JSON.stringify(this.selectedOrder));
        newOrders.map((v) => {
          v.isDraggable = true;
          v.sales_quantity = 0;
          this.itemList.splice(v.oldIndex, 1, v);
          return false;
        });
      } else {
        let item = this.itemList.find((i) => i.id == this.singleOrderId);
        let newItem = JSON.parse(JSON.stringify(item));
        let index = this.itemList.findIndex((v) => v.id == this.singleOrderId);
        item.oldIndex = index;
        item.isChecked = false;
        this.splittedOrderList[orderIndex].orderItem.push(item);

        newItem.isDraggable = true;
        newItem.sales_quantity = 0;
        this.itemList.splice(index, 1, newItem);
        this.singleOrderId = null;
      }
    },
    getOrderDetails() {
      bus.$emit("showLoader", true);
      this.$api.orderNew
        .getOrderView(this.$route.params.id)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.orderDetails = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getItemList(params = {}) {
      params = {
        order: this.$route.params.id,
        limit: "all",
      };
      bus.$emit("showLoader", true);
      this.$api.order
        .getOrderItemList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.itemList = res.data;
          this.dbItemList = JSON.parse(JSON.stringify(res.data));
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    submitForm() {
      let listOfItems = this.splittedOrderList[0].orderItem.map((v) => {
        return {
          sales_quantity: v.sales_quantity,
          id: v.id,
        };
      });

      let data = {
        new_execution_date: this.orderDetails.execution_date,
        order_item_id_list: listOfItems,
      };

      this.$api.orderNew
        .getSplitOrder({
          id: this.$route.params.id,
          data: data,
        })
        .then(() => {
          bus.$emit("showToastMessage", {
            message: "Order splitted successfully",
            color: "success",
          });
          this.$router.push({ name: "order-new" });
        })
        .catch((err) => {
          console.error(err);
          if (
            err.data &&
            err.data.order_item_id_list &&
            err.data.order_item_id_list.length > 0
          ) {
            this.formErrors = err.data;
          }
          if (
            err &&
            err.data &&
            err.data.non_field_errors &&
            err.data.non_field_errors.length > 0
          ) {
            bus.$emit("showToastMessage", {
              message: err.data.non_field_errors[0],
              color: "error",
            });
          }
        });
    },
  },
  mounted() {
    if ("id" in this.$route.params) {
      this.getItemList();
      this.getOrderDetails();
    }
    // if(this.$router)
  },
};
</script>

<style></style>
